import {
  Control,
  Controller,
  UseFormGetValues,
  useWatch,
} from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Enum } from '~/data/enums';
import {
  getCountryByLegalEntity,
  useAllLegalEntities,
} from '~/data/legalEntity';
import { useSxStyles } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/components/Employment/components/FormComponent/useStyles';
import { Form } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/useScheduleChanges';
import { LegacyAutocompleteField } from '~/legacy-components/LegacyForms';
import { filterActiveEnumsByCountryAndOrgUnits } from '~/utils/helper';

type Props = {
  control: Control<Form>;
  getValues: UseFormGetValues<Form>;
  fixedTermReasons: Enum[];
  index: number;
};

export const FixedTermReasonComponent = ({
  control,
  fixedTermReasons,
  index,
  getValues,
}: Props) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  //@ts-ignore
  useWatch({
    control,
    name: `schedule.${index}.empPosition.fEmpLegalEntity`,
  });

  useWatch({
    control,
    name: `schedule.${index}.empPosition.fInternalPositionUnit`,
  });

  const fEmpLegalEntityValue = getValues(
    `schedule.${index}.empPosition.fEmpLegalEntity`,
  );

  const fEmpOrgUnitValue = getValues(
    `schedule.${index}.empPosition.fInternalPositionUnit`,
  );

  const { legalEntities } = useAllLegalEntities();

  const filteredOptions = filterActiveEnumsByCountryAndOrgUnits(
    fixedTermReasons,
    getCountryByLegalEntity(+fEmpLegalEntityValue, legalEntities),
    fEmpOrgUnitValue,
  );

  return (
    <Controller
      control={control}
      name={`schedule.${index}.employment.fEmplFixedTermReason`}
      render={({ field: { onChange, value } }) => (
        <LegacyAutocompleteField
          options={filteredOptions}
          getOptionLabel={(o) => o?.name || ''}
          isOptionEqualToValue={(o, v) => o?.code === v?.code}
          onChange={(_, value) => onChange(value?.code || '')}
          value={filteredOptions.find((o) => o?.code === value) || null}
          sx={sxStyles.selectStyle}
          label={t('fReasonFixTerm')}
        />
      )}
    />
  );
};
